import { AssignmentExtendedModel, CaseTypeEnum } from 'api/model';
import AssignmentsList from 'components/AssignmentsList';
import Routes from 'constants/Routes';
import { TableIdentifierEnum } from 'contexts/basicData/useActiveColumns';
import useFilteredAssignments from 'pages/Assignments/useFilteredAssignments';
import { Outlet, useNavigate } from 'react-router-dom';
import TestDrivesFilterBar from './components/TestDrivesFilterBar';
import useModalStack from 'contexts/modal/useModalStack';
import SendCasesToFieldTestersModal from 'pages/Assignments/SendCasesToFieldTestersModal';

const TestDrivesPage = () => {
  const navigate = useNavigate();
  const modalStack = useModalStack();
  const { filteredAssignments, update } = useFilteredAssignments(
    CaseTypeEnum.TestDrive
  );

  const handleAssignmentItemClick = (model: any) => {
    const avm = model as AssignmentExtendedModel;
    navigate(
      `${Routes.internalDeliveryGroup.testDrives.index}/${avm.case.caseID}?assignment=${
        avm.assignment.assignmentID
      }`
    );
  };

  return (
    <>
      <TestDrivesFilterBar
        assignments={filteredAssignments}
        onSendToFieldTestersClick={() => {
          modalStack.push(
            <SendCasesToFieldTestersModal
              onAssignmentsSent={() => {
                modalStack.pop();
                update(false);
              }}
              onCancel={() => {
                modalStack.pop();
                update(false);
              }}
              includeCaseTypes={[CaseTypeEnum.TestDrive]}
              caseType={CaseTypeEnum.TestDrive}
            />
          );
        }}
        onUpdate={() => update(false)}
      />
      <AssignmentsList
        loading={false}
        tableIdentifier={
          TableIdentifierEnum.InternalDeliveryGroupAssignmentsTable
        }
        assignments={filteredAssignments}
        onAssignmentItemClick={handleAssignmentItemClick}
        onAssignmentUpdated={async () => {
          update(false);
        }}
        hideEstimatedDurationAndStartTime
        showStatusColors={false}
      />
      <Outlet />
    </>
  );
};

export default TestDrivesPage;
